// src/services/postService.js
import apiService from './api';

const postService = {
  // Get all posts with pagination
  getPosts: async (page = 1, limit = 10) => {
    try {
      return await apiService.get('/posts', { page, limit });
    } catch (error) {
      throw error;
    }
  },

  // Get a single post by ID
  getPost: async (postId) => {
    try {
      return await apiService.get(`/posts/${postId}`);
    } catch (error) {
      throw error;
    }
  },

  // Get posts by category
  getPostsByCategory: async (category, page = 1, limit = 10) => {
    try {
      return await apiService.get(`/posts/categories/${category}`, { page, limit });
    } catch (error) {
      throw error;
    }
  },

  // Get posts by user ID
  getUserPosts: async (userId, page = 1, limit = 10) => {
    try {
      return await apiService.get(`/posts/users/${userId}`, { page, limit });
    } catch (error) {
      throw error;
    }
  },

  // Get personalized feed
  getFeed: async (page = 1, limit = 10) => {
    try {
      return await apiService.get('/posts/feed', { page, limit });
    } catch (error) {
      throw error;
    }
  },

  // Get trending posts
  getTrendingPosts: async (page = 1, limit = 10) => {
    try {
      return await apiService.get('/posts/trending', { page, limit });
    } catch (error) {
      throw error;
    }
  },

  // Get related posts
  getRelatedPosts: async (postId, limit = 5) => {
    try {
      return await apiService.get(`/posts/${postId}/related`, { limit });
    } catch (error) {
      throw error;
    }
  },

  // Search posts
  searchPosts: async (query, page = 1, limit = 10) => {
    try {
      return await apiService.get('/posts/search', { q: query, page, limit });
    } catch (error) {
      throw error;
    }
  },

  // Create a new post
  createPost: async (postData, onProgress) => {
    try {
      return await apiService.upload('/posts', postData, onProgress);
    } catch (error) {
      throw error;
    }
  },

  // Update an existing post
  updatePost: async (postId, postData, onProgress) => {
    try {
      return await apiService.upload(`/posts/${postId}`, postData, onProgress);
    } catch (error) {
      throw error;
    }
  },

  // Delete a post
  deletePost: async (postId) => {
    try {
      return await apiService.delete(`/posts/${postId}`);
    } catch (error) {
      throw error;
    }
  },

  // Share a post
  sharePost: async (postId, comment = '') => {
    try {
      return await apiService.post(`/posts/${postId}/share`, { comment });
    } catch (error) {
      throw error;
    }
  },

  // Like or unlike a post
  toggleLike: async (postId) => {
    try {
      return await apiService.post('/likes', {
        targetId: postId,
        targetType: 'post'
      });
    } catch (error) {
      throw error;
    }
  },

  // Get likes for a post
  getLikes: async (postId) => {
    try {
      return await apiService.get('/likes', {
        targetId: postId,
        targetType: 'post'
      });
    } catch (error) {
      throw error;
    }
  },

  // Check if user has liked a post
  checkLike: async (postId) => {
    try {
      return await apiService.get('/likes/check', {
        targetId: postId,
        targetType: 'post'
      });
    } catch (error) {
      throw error;
    }
  }
};

export default postService;